export const secondsToTime = (seconds) => {
    var time = "00:00"
    var s = seconds + 3600
    // if (s < 0){
    //     s = s * -1
    // }
    const sec = 120 - s
    if (s < 3600){
        time = new Date(sec * 1000).toISOString().substring(14, 19)
    } else {
        time = new Date(sec * 1000).toISOString().substring(11, 16)
    }
    console.log("timerTime = " + sec)
    console.log("timerTime s = " + s)
    return time
}
export const secondsToTimeGroupCall = (seconds) => {
    var time = "00:00"
    var sec = seconds > 0 ? seconds : seconds*-1
    // if (s < 0){
    //     s = s * -1
    // }
    if (sec < 3600){
        time = new Date(sec * 1000).toISOString().substring(14, 19)
    } else {
        time = new Date(sec * 1000).toISOString().substring(11, 16)
    }
   
    return time
}